export function calculatePercentage(weight: number, totalWeight: number, precision: number | undefined = 4) {
  if (!totalWeight || !weight) {
    return 0;
  }
  return roundToPrecision((weight / totalWeight) * 100, precision);
}

export function calculateWeightFromPercentage(
  percentage: number,
  totalWeight: number,
  precision: number | undefined = 4,
) {
  if (!totalWeight || !percentage) {
    return 0;
  }
  return roundToPrecision(percentage * totalWeight, precision) / 100;
}

/**
 * Rounds your float value to a given precision (3 by default)
 */
export const roundToPrecision = (toRound: number, precision: number = 3): number => {
  return Math.round((toRound + Number.EPSILON) * Math.pow(10, precision)) / Math.pow(10, precision);
};

/**
 * Checks that the weight corresponds to the average weight with a delta. All weights are in kilograms.
 */
export const isWeightAgainstAvegerageWeight = (
  conditioningQuantity: number,
  weight: number,
  averageWeight: number,
  delta: number,
): boolean => {
  delta = ((conditioningQuantity * averageWeight) / 100) * delta;
  averageWeight = averageWeight * conditioningQuantity;
  return !(weight > averageWeight + delta || weight < averageWeight - delta);
};

/**
 * Calcul any percentage with precision.
 */
export const calculatePercentageWithPrecision = (percentage: number, precision: number | undefined = 4): string => {
  return roundToPrecision(percentage * 100, precision).toFixed(precision);
};
